// Recovered compiled webpack factory 51118. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { K: () => n });
  function n(t, e) {
    if (t?.inherit && e) {
      let { inherit: i, ...n } = t;
      return { ...e, ...n };
    }
    return t;
  }
}
